import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AssessContributionToCostsComponent } from './apportionment/assess-contribution-to-costs/assess-contribution-to-costs.component';
import { OutlineExposureComponent } from './investigation/outline-exposure/outline-exposure.component';
import { AudiometryFormComponent } from './investigation/audiometry-form/audiometry-form.component';
import { AudiogramAnalyseComponent } from './investigation/audiogram-analyse/audiogram-analyse.component';
import { OutlineExposureListingComponent } from './investigation/outline-exposure-listing/outline-exposure-listing.component';
import { AudiogramCompareComponent } from './investigation/audiogram-compare/audiogram-compare.component';
import { WizardComponent } from '../wizard/wizard.component';
import { NihlAnalyseGuard } from 'src/app/guards/nihl-analyse.guard';
import { AudiogramCompareGuard } from 'src/app/guards/audiogram-compare.guard';


const routes: Routes = [
  {
    path: 'apportionment/assess-contribution-to-costs/:claimId/:taskId',
    component: WizardComponent,
  },
  {
    path: 'investigation/outline-exposure/edit/:claimId/:taskId/:exposureId',
    component: OutlineExposureComponent,
  },
  {
    path: 'investigation/outline-exposure/add/:claimId/:taskId',
    component: OutlineExposureComponent,
  },
  {
    path: 'investigation/outline-exposure/:claimId/:taskId',
    component: OutlineExposureListingComponent,
  },
  {
    path: 'investigation/create-audiometry/:claimId/:taskId',
    component: AudiometryFormComponent,
  },
  {
    path: 'investigation/edit-audiometry/:claimId/:taskId/:testId',
    component: AudiometryFormComponent,
  },
  {
    path: 'investigation/audiogram-analyse/:claimId/:taskId/:testId',
    component: AudiogramAnalyseComponent,
    canDeactivate: [NihlAnalyseGuard]
  },
  {
    path: 'investigation/compare-audiograms/:claimId/:taskId/:createAudiometryTaskId',
    component: AudiogramCompareComponent,
    canDeactivate: [AudiogramCompareGuard]
  },
  {
    path: 'outcome',
    loadChildren: () => import('./outcome/outcome.module').then(mod => mod.OutcomeModule),
  },
  {
    path: 'limitation',
    loadChildren: () => import('./limitation/limitation.module').then(mod => mod.LimitationModule),
  }
  
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)],

})
export class NihlRoutingModule { }
